import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AslibModalComponent, AslibModalService } from '@aslib/modal';
import { AslibLoadingService } from '@aslib/loading';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from '../../../shared/helpers/modal-manager-helper';
import { ShowFile } from '../../../shared/helpers/show-file';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';


@Component({
  selector: 'sarf-gerar-valor-mensal-municipio',
  templateUrl: './gerar-valor-mensal-municipio.component.html'
})


export class GerarValorMensalDistribuir implements OnInit {
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  aslibModal: AslibModalComponent;
  dataReferenciaDistribuicao: string;
  valorMensalDistribuicao: number;
  showFile: ShowFile;
  exibirGrid:boolean = false;
  listaDistribuicaoGerada: any[];
  listaDistribuicao: any[] = [
    {
      municipio: 'Município A',
      indiceIMP: 0.5000,
      valorDistribuido: 0,
      valorArredondado: 0
    },
    {
      municipio: 'Município B',
      indiceIMP: 0.3540,
      valorDistribuido: 0,
      valorArredondado: 0
    },
    {
      municipio: 'Município C',
      indiceIMP: 0.2200,
      valorDistribuido: 0,
      valorArredondado: 0
    }
  ];
  valorDistruibuir:any[] = [
    {
      referencia: '08/2025',
      valorTotal: 1000520.20}
  ];
  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent;
  

  constructor(
    private router: Router,
    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    private readonly _aslibModalService: AslibModalService,

  ) {
    modalManagerHelper.parent = this;
    
  }

formGeraroValorMensalDistribuir = new FormGroup({
  dataReferenciaDistribuicao: new FormControl('', Validators.required),
  valorMensalDistribuicao: new FormControl('', Validators.required),
  });

  ngOnInit() {
  
  }

 irPraConsulta(){
   this.router.navigate(['/royalts/sarf-consulta-valor-mensal-municipio']);
 }
  
  exibirSucesso(mesano:string){
    var texto = "Valor dos royalties a distribuir de {MM/AAAA} cadastrado com sucesso.";
            
    this._aslibLoadingService.complete();
    
    new AslibModalComponent(this._aslibModalService).open(
      {
        title: 'Mensagem',
        text: texto,
        type: 'info'
      }
    );
  } 

  exibirJaExisteMesAno(mesano:string){
    var texto = "Não existe valor de royalties cadastrado para o {mês/ano} informado.";
            
    var item = this.valorDistruibuir.find(x => x.referencia == mesano);
    this._aslibLoadingService.complete();
    if(item){
      this.formGeraroValorMensalDistribuir.get('valorMensalDistribuicao').setValue(item.valorTotal);
    }else{  
      this.formGeraroValorMensalDistribuir.get('valorMensalDistribuicao').setValue(null);

    new AslibModalComponent(this._aslibModalService).open(
      {
        title: 'Mensagem',
        text: texto,
        type: 'info'
      }
    );}
  } 

  exibirError(){
    var texto = "Ocorreu um erro ao tentar incluir o registro informado.";
            
    this._aslibLoadingService.complete();
    
    new AslibModalComponent(this._aslibModalService).open(
      {
        title: 'Mensagem',
        text: texto,
        type: 'info'
      }
    );
  } 

consultarValorDistribuicaoValorMensal(modalMensagem:AslibLoadingService){
    //Simular consulta
    this.exibirJaExisteMesAno(this.dataReferenciaDistribuicao);
}

gerarDistribuicaoValorMensal(modalMensagem:AslibLoadingService){
    this.listaDistribuicaoGerada = [];    
    this.valorMensalDistribuicao = this.formGeraroValorMensalDistribuir.get('valorMensalDistribuicao').value;
   
    this.listaDistribuicao.forEach(element => {     
      const valorDistribuido = this.valorMensalDistribuicao * element.indiceIMP;
      const valorDistribuidoStr = valorDistribuido.toFixed(4); // 4 casas
      const valorArredondadoStr = valorDistribuido.toFixed(2); // 2 

      this.listaDistribuicaoGerada.push({
        ...element,
        valorDistribuido: valorDistribuidoStr,
        valorArredondado: valorArredondadoStr
      });
    });
    this.exibirGrid = true;
}
public limparConsulta(){
      this.formGeraroValorMensalDistribuir.reset();
      this.dataReferenciaDistribuicao = null;
      this.valorMensalDistribuicao = null;
 }

  unSubscribe() {
    this._aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/royalts/cadastra-valor-mensal/gerar-valor-mensal/gerar-valor-mensal-municipio.component.ts